<div id="homepage" class="{{pageRoute}}" on>
  <ng-template #dynamic>

  </ng-template>
</div>
